import { type PropsWithChildren, type ReactNode, useRef } from 'react';
import { twMerge } from 'tailwind-merge';
import { default as MuiListItem } from '@mui/material/ListItem';
import { deepMerge } from '@witmetrics/utils/objects';
import { useToggle } from '@/hooks/useToggle';
import Card, { type CardProps } from '@/components/Card';
import { OptionsIcon } from '@/icons';
import { classes, styles } from './utils';

export interface CardListItemProps extends PropsWithChildren {
  className?: string;
  sx?: CardProps['sx'];
  renderIcon?: () => ReactNode;
  renderMenu: (
    open: boolean,
    ref: HTMLElement | null,
    onClose: () => void
  ) => ReactNode;
}

export default function CardListItem({
  className,
  sx = {},
  children,
  renderIcon,
  renderMenu,
}: CardListItemProps) {
  const menuToggleRef = useRef(null);
  const [isMenuOpen, toggleMenu] = useToggle();

  return (
    <MuiListItem disablePadding>
      <Card
        sx={deepMerge(styles.card, sx || {})}
        className={twMerge(classes.card, className)}>
        {renderIcon && (
          <div className={classes.itemIconWrapper}>{renderIcon()}</div>
        )}
        <div className={classes.content}>{children}</div>
        <div className={classes.optionsWrapper}>
          <OptionsIcon
            ref={menuToggleRef}
            className={classes.optionsIcon}
            onClick={() => toggleMenu()}
          />
          {renderMenu(isMenuOpen, menuToggleRef.current, () =>
            toggleMenu(false)
          )}
        </div>
      </Card>
    </MuiListItem>
  );
}
